export default __webpack_public_path__ + "svgs/sat1-3dcbba68.svg";